export default "__VITE_PUBLIC_ASSET__1e22fedf__"